import { createContext } from 'react';
import { MeetingData } from '../../../shared/types/types';
import { pendingMeetingData } from '../../../database/utils/templateMeetingData';

const MeetingDataContext = createContext<MeetingData>(pendingMeetingData);

export default MeetingDataContext;
